import { Avatar, Box, Stack, Typography } from "@mui/material";
import moment from "moment/moment";
import React, { useState } from "react";
import Loader from "../../../../common/Loader";

function PictureViewer({ file, showDetails }) {
  const [loading, setLoading] = useState(true);
  return (
    <Box>
      <img
        style={{
          height: "auto",
          maxHeight: " 60vh",
          minWidth: "90%",
          width: "100%",
          objectFit: "contain",
        }}
        src={file?.fileUrl}
        alt={file?.name}
        loading="lazy"
        onLoad={() => {
          setLoading(false);
        }}
      />

      {loading && (
        <div
          style={{
            position: "absolute",
            top: "30%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "white",
            fontSize: "4rem",
          }}
        >
          <Loader />
        </div>
      )}
      {showDetails && (
        <Stack sx={{ mt: 0.5, wordSpacing: 1,
            lineHeight: "0.9rem",
            overflow: "scroll",
            scrollbarWidth: "none", }} onClick={(e) => {}}
        >
          <Stack sx={{ justifyContent: "space-between", alignItems: "center" }} direction={"row"} className="other-stack-adjust">
            <Stack direction={"row"}  sx={{ gap: 1, alignItems: "center" }}>
              <Avatar alt="Remy Sharp" src={file?.userProfilePicture} />
              <Typography>{file?.userName}</Typography>
            </Stack>
            <Typography>
              {moment(file?.dateCreated).format("MMMM DD, YYYY")}
            </Typography>
          </Stack>
          <Typography
            maxHeight={"100px"}
            overflow={"scroll"}
            variant="body2"
            sx={{ mt: 1 }}
          >
            {file?.description}
          </Typography>
        </Stack>
      )}
    </Box>
  );
}

export default PictureViewer;
